import Swiper from 'swiper';
import 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const SELECTORS = {
	section: '.section-resources-feed',
	thumb: '.js-resources-feed-thumb',
	featured: '.js-resources-feed-featured',
	featuredImg: '.js-resources-feed-featured-img',
	featuredTitle: '.js-resources-feed-featured-title',
	featuredDate: '.js-resources-feed-featured-date',
	featuredLinkMedia: '.js-resources-feed-featured-link-media',
	featuredCta: '.js-resources-feed-featured-cta',
	featuredCtaLabel: '.js-resources-feed-featured-cta-label',
	featuredActions: '.resources-feed-featured__actions',
	featuredEntry: '.resources-feed-featured__entry',
	mobileSlider: '.js-resources-feed-mobile-slider',
	nextButton: '.swiper-button-next',
	prevButton: '.swiper-button-prev',
};

const strAttr = function( value, fallback = '' ) {
	if ( value === undefined || value === null ) {
		return fallback;
	}
	return String( value );
};

const resourcesUrlFromAttr = function( raw ) {
	if ( !raw ) {
		return '#';
	}
	return String( raw );
};

/**
 * @param {JQuery} $thumb
 * @returns {{ imageUrl: string | undefined, title: string, date: string, dateIso: string, resourcesUrl: string, buttonUrl: string, buttonTitle: string, buttonTarget: string }}
 */
const readThumbSelectionState = function( $thumb ) {
	return {
		imageUrl: $thumb.attr( 'data-image' ),
		title: strAttr( $thumb.attr( 'data-title' ) ),
		date: strAttr( $thumb.attr( 'data-date' ) ),
		dateIso: strAttr( $thumb.attr( 'data-date-iso' ) ),
		resourcesUrl: resourcesUrlFromAttr( $thumb.attr( 'data-resources-url' ) ),
		buttonUrl: strAttr( $thumb.attr( 'data-button-url' ) ),
		buttonTitle: strAttr( $thumb.attr( 'data-button-title' ) ),
		buttonTarget: strAttr( $thumb.attr( 'data-button-target' ), '_self' ),
		content: strAttr( $thumb.attr( 'data-content' ) ),
	};
};

/**
 * @param {JQuery} $featured
 * @param {JQuery} $section
 * @param {{ imageUrl: string | undefined, title: string, date: string, dateIso: string, resourcesUrl: string }} state
 */
const updateFeaturedMain = function( $featured, $section, state ) {
	const { imageUrl, title, date, dateIso, resourcesUrl, buttonUrl, buttonTitle, buttonTarget, content } = state;
	const hasCta = Boolean( buttonUrl && buttonTitle.trim() );
	$featured.find( SELECTORS.featuredImg ).attr( 'src', imageUrl );
	$featured.find( SELECTORS.featuredTitle ).text( title );
	$featured.find( SELECTORS.featuredDate ).text( date ).attr( 'datetime', dateIso );
	$section.find( SELECTORS.featuredLinkMedia )
		.attr( 'href', hasCta ? buttonUrl : resourcesUrl )
		.attr( 'target', buttonTarget );
	$featured.find( SELECTORS.featuredEntry ).html( '<p>' + content + '</p>' );
};

/**
 * @param {JQuery} $featured
 * @returns {JQuery}
 */
const getOrCreateFeaturedActions = function( $featured ) {
	let $row = $featured.find( SELECTORS.featuredActions );
	if ( $row.length ) {
		return $row;
	}
	$row = $( '<div>', { class: 'resources-feed-featured__actions' } );
	$featured.find( SELECTORS.featuredEntry ).after( $row );
	return $row;
};

/**
 * @param {JQuery} $actions
 * @returns {{ $cta: JQuery, $ctaLabel: JQuery }}
 */
const getOrCreateFeaturedCtaLink = function( $actions ) {
	let $cta = $actions.find( SELECTORS.featuredCta );
	if ( $cta.length ) {
		return { $cta, $ctaLabel: $cta.find( SELECTORS.featuredCtaLabel ) };
	}
	$cta = $( '<a>', {
		class: 'resources-feed-featured__btn btn btn--primary js-resources-feed-featured-cta',
		href: '#',
		target: '_self',
	} );
	const $ctaLabel = $( '<span>', { class: 'js-resources-feed-featured-cta-label' } );
	$cta.append( $ctaLabel );
	$actions.append( $cta );
	return { $cta, $ctaLabel };
};

/**
 * @param {JQuery} $actions
 * @param {JQuery} $cta
 * @param {JQuery} $ctaLabel
 * @param {{ buttonUrl: string, buttonTitle: string, buttonTarget: string }} state
 */
const revealFeaturedCta = function( $actions, $cta, $ctaLabel, state ) {
	const { buttonUrl, buttonTitle, buttonTarget } = state;
	$actions.removeAttr( 'hidden' );
	$cta.removeAttr( 'hidden' );
	$cta.removeAttr( 'aria-hidden' );
	$cta.removeAttr( 'tabindex' );
	$cta.attr( 'href', buttonUrl ).attr( 'target', buttonTarget );
	$ctaLabel.text( buttonTitle );
};

/**
 * @param {JQuery} $featured
 */
const clearFeaturedCta = function( $featured ) {
	$featured.find( SELECTORS.featuredActions ).remove();
};

/**
 * @param {JQuery} $featured
 * @param {{ buttonUrl: string, buttonTitle: string, buttonTarget: string }} state
 */
const updateFeaturedCta = function( $featured, state ) {
	const { buttonUrl, buttonTitle } = state;
	const has = Boolean( buttonUrl && buttonTitle.trim() );
	if ( !has ) {
		clearFeaturedCta( $featured );
		return;
	}
	const $actions = getOrCreateFeaturedActions( $featured );
	const { $cta, $ctaLabel } = getOrCreateFeaturedCtaLink( $actions );
	revealFeaturedCta( $actions, $cta, $ctaLabel, state );
};

/**
 * @param {JQuery} $section
 * @param {JQuery} $activeThumb
 */
const syncThumbActiveState = function( $section, $activeThumb ) {
	$section.find( SELECTORS.thumb ).each( function() {
		const $btn = $( this );
		const isSelected = $btn[0] === $activeThumb[0];
		$btn.toggleClass( 'is-active', isSelected );
		$btn.attr( 'aria-pressed', isSelected ? 'true' : 'false' );
	} );
};

const applySelection = function( $section, $thumb ) {
	const state = readThumbSelectionState( $thumb );
	const $featured = $section.find( SELECTORS.featured );
	updateFeaturedMain( $featured, $section, state );
	updateFeaturedCta( $featured, state );
	syncThumbActiveState( $section, $thumb );
};

const initMobileSlider = function( $section ) {
	const $slider = $section.find( SELECTORS.mobileSlider );

	if ( !$slider.length || $slider[0].swiper ) {
		return;
	}

	new Swiper( $slider[0], {
		slidesPerView: 1,
		spaceBetween: 20,
		speed: 600,
		watchOverflow: true,
		autoHeight: true,
		navigation: {
			nextEl: $slider.find( SELECTORS.nextButton )[0],
			prevEl: $slider.find( SELECTORS.prevButton )[0],
		},
	} );
};

const initBlock = function( $block ) {
	$block.each( function() {
		const $section = $( this );

		$section.on( 'click', SELECTORS.thumb, function( e ) {
			const $thumb = $( this );
			if ( $thumb.hasClass( 'is-active' ) ) {
				return;
			}
			e.preventDefault();
			applySelection( $section, $thumb );
		} );

		initMobileSlider( $section );
	} );
};

app.loadBlock( initBlock, 'resources-feed', SELECTORS.section );

if ( module.hot ) {
	module.hot.accept();
}
